import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import HomeIcon from '@mui/icons-material/Home';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 140px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
        py: 8
      }}>
      <Container maxWidth='md'>
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <Box sx={{ textAlign: 'center' }}>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                delay: 0.2,
                type: 'spring',
                stiffness: 200
              }}>
              <SearchOffIcon
                sx={{
                  fontSize: { xs: 100, md: 150 },
                  color: '#666',
                  mb: 3,
                  opacity: 0.7
                }}
              />
            </motion.div>

            <Typography
              variant='h1'
              sx={{
                fontSize: { xs: '4rem', md: '8rem' },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 2,
                lineHeight: 1
              }}>
              404
            </Typography>

            <Typography
              variant='h4'
              sx={{
                mb: 2,
                fontWeight: 600,
                color: '#1a1a1a',
                fontSize: { xs: '1.5rem', md: '2rem' }
              }}>
              Seite nicht gefunden
            </Typography>

            <Typography
              variant='body1'
              sx={{
                mb: 5,
                color: '#666',
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.7,
                maxWidth: 600,
                mx: 'auto'
              }}>
              Die von Ihnen gesuchte Seite existiert leider nicht. Sie wurde möglicherweise verschoben oder gelöscht.
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Button
                  variant='contained'
                  size='large'
                  startIcon={<HomeIcon />}
                  onClick={() => navigate('/')}
                  sx={{
                    px: 4,
                    py: 1.5,
                    background: '#000',
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: '1rem',
                    '&:hover': {
                      background: '#333'
                    }
                  }}>
                  Zur Startseite
                </Button>
              </motion.div>

              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Button
                  variant='outlined'
                  size='large'
                  onClick={() => navigate(-1)}
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderColor: '#000',
                    color: '#000',
                    fontWeight: 600,
                    fontSize: '1rem',
                    '&:hover': {
                      borderColor: '#333',
                      background: 'rgba(0,0,0,0.05)'
                    }
                  }}>
                  Zurück
                </Button>
              </motion.div>
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default NotFound;
